// extracted by mini-css-extract-plugin
module.exports = {"main":"Projects_main__2kLVY","load":"Projects_load__3uNhB"};